var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLightbulb = function SvgLightbulb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lightbulb",
    clipPath: "url(#clip0_3403_2333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8748 25.375C10.8748 26.0395 11.4186 26.5833 12.0832 26.5833H16.9165C17.5811 26.5833 18.1248 26.0395 18.1248 25.375V24.1666H10.8748V25.375ZM14.4998 2.41663C9.83567 2.41663 6.0415 6.21079 6.0415 10.875C6.0415 13.7508 7.47942 16.2762 9.6665 17.8108V20.5416C9.6665 21.2062 10.2103 21.75 10.8748 21.75H18.1248C18.7894 21.75 19.3332 21.2062 19.3332 20.5416V17.8108C21.5203 16.2762 22.9582 13.7508 22.9582 10.875C22.9582 6.21079 19.164 2.41663 14.4998 2.41663ZM17.9436 15.8291L16.9165 16.5541V19.3333H12.0832V16.5541L11.0561 15.8291C9.42484 14.6933 8.45817 12.8445 8.45817 10.875C8.45817 7.53996 11.1648 4.83329 14.4998 4.83329C17.8348 4.83329 20.5415 7.53996 20.5415 10.875C20.5415 12.8445 19.5748 14.6933 17.9436 15.8291Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3403_2333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLightbulb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lightbulb.8485ad4d.svg";
export { ForwardRef as ReactComponent };